
import Backward from "../../../assets/filled/Backward.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BackwardIcon({ className, dataTestid = "BackwardIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Backward data-testid={dataTestid} className={classes} {...rest} />
  );
}
